import { SearchMenuPipe } from './search-submenu/search-submenu.pipe';
import { TruncatePipe } from './truncate/truncate.pipe';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// import { TranslationShared } from './translation/translation-shared.module';
import { LoadingComponent } from './loading/loading.component';
import { SplitPipe } from './split/split.pipe';

const Elements = [
  SearchMenuPipe, 
  TruncatePipe, 
  LoadingComponent, 
  SplitPipe
]

@NgModule({
  declarations: [SearchMenuPipe, 
    TruncatePipe, 
    LoadingComponent, 
    SplitPipe],
  exports: [SearchMenuPipe, 
    TruncatePipe, 
    LoadingComponent, 
    SplitPipe],
  imports: [
    CommonModule
  ]
})
export class AppSharedModule { }
